import { render, staticRenderFns } from "./ProviderService.vue?vue&type=template&id=1bcb2ff2&scoped=true&lang=pug&"
import script from "./ProviderService.vue?vue&type=script&lang=js&"
export * from "./ProviderService.vue?vue&type=script&lang=js&"
import style0 from "./ProviderService.vue?vue&type=style&index=0&id=1bcb2ff2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcb2ff2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VBtn,VDataTable,VIcon,VSpacer})
